import React, { Fragment } from 'react';
import { useRouter } from 'next/router';

import PricesAndPlansHero from './PricesAndPlansHero';
import PricesAndPlansTypes from './PricesAndPlansTypes';
import PricesAndPlansDocuments from './PricesAndPlansDocuments';
import BannerCustom from '../BannerCustom';

import styles from './PricesAndPlans.module.scss';

import componentsId from '../../utils/componentsId';
import { pricesAndPlansText } from '../../utils/generalTexts';
import routes from '../../utils/routes';
import { CAT } from '../../utils/assets';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { planPageEvents } from '@/utils/dataLayer/planPage';

type PricesAndPlansT = {
  loading: boolean;
};

const PricesAndPlans = ({ loading }: PricesAndPlansT) => {
  const router = useRouter();

  const btnEstimateClick = () => {
    trackEvent({
      eventParams: {
        ...planPageEvents.quoteFooter,
      },
    });
    router.push(routes.wizardPlan);
  };

  return (
    <Fragment>
      <PricesAndPlansHero
        title={pricesAndPlansText.hero.title}
        text={pricesAndPlansText.hero.text}
        btn={pricesAndPlansText.hero.btn}
      />
      {!loading && <PricesAndPlansTypes />}
      <PricesAndPlansDocuments />
      <BannerCustom
        id={componentsId.pricesAndPlans.banner.section}
        img={CAT.CAT_BANNER_LANDING_MOBILE}
        title={pricesAndPlansText.banner.description}
        callToAction={{
          id: componentsId.pricesAndPlans.banner.button,
          text: pricesAndPlansText.banner.button,
          onClick: btnEstimateClick,
          icon: 'arrow_forward',
          iconFirst: false,
        }}
        className={styles.prices_and_plans_banner}
      />
    </Fragment>
  );
};

export default PricesAndPlans;
